let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dhvtB")).then(() => parcelRequire('9RToo'));